// extracted by mini-css-extract-plugin
export default {"draggableButton":"styles_draggable-button__c-ZI6"};